module.exports = __webpack_public_path__ + "img/fan.4f500c34.png";